import React from 'react'
import './Motivation.css'

const Motivation = () => {
    return (
        <div className='motivation-container'>
            <div className='motivation-text'>
                <span>THE <span className='stroke-text1'>ONLY</span></span>
                <span className='stroke-text1 fill-text'>IMPOSSIBLE</span>
                <span>
                    <span className='stroke-text1'>JOURNEY</span>
                    <span>  IS</span>
                </span>
                <span >THE ONE <span className='stroke-text1'>YOU</span></span>
                <span><span className='stroke-text1'>NEVER </span>BEGIN</span>
            </div>
        </div>
    )
}

export default Motivation
